import script from "./recommendItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./recommendItem.vue?vue&type=script&lang=ts&setup=true"

import "./recommendItem.vue?vue&type=style&index=0&id=64ae94b0&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ae94b0"]])

export default __exports__